module.exports = __webpack_public_path__ + "img/avator.d186df13.png";